<div class="config-content">
    <div class="config-fields">
        <mat-form-field appearance="outline" class="type-input" subscriptSizing="dynamic">
            <mat-label>
                {{'events.metric_model_type'|translate}}
            </mat-label>
            
            <mat-select [(ngModel)]="config.type" name="type">
                <mat-select-trigger>
                    <div class="option-with-icon">
                        <mat-icon>{{ getTypeIcon(config.type) }}</mat-icon>
                        <span>{{"form."+config.type|translate}}</span>
                    </div>
                </mat-select-trigger>

                @for(ft of fieldTypes; track ft) {
                <mat-option [value]="ft">
                    <div class="option-with-icon">
                        <mat-icon>{{ getTypeIcon(ft) }}</mat-icon>
                        <span>{{"form."+ft|translate}}</span>
                    </div>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="type-input" subscriptSizing="dynamic">
            <mat-label>
                {{'events.metric_model_label'|translate}}
            </mat-label>

            <input type="text" [(ngModel)]="config.label" name="label" aria-label="text" matInput
                (change)="onLabelChanged()">
        </mat-form-field>

        @if(config.type == 'number'){
        <mat-form-field class="type-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>
                {{'events.metric_model_value'|translate}}
            </mat-label>

            <input type="number" [(ngModel)]="config.value" name="value" aria-label="text" matInput>
        </mat-form-field>
        }

        @if(config.type == 'text'){
        <mat-form-field class="type-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>
                {{'events.metric_model_value'|translate}}
            </mat-label>

            <input type="text" [(ngModel)]="config.value" name="value" aria-label="text" matInput>
        </mat-form-field>
        }

        @if(config.type == 'select'){
        <mat-form-field class="select-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>
                {{'events.metric_model_newoption'|translate}}
            </mat-label>

            <input type="text" [(ngModel)]="config.newOption" name="newOption" aria-label="text" matInput
                placeholder="{{'events.metric_model_newoption'|translate}}" (keyup.enter)="addOption()">
            <mat-icon matSuffix class="option-add-icon" (click)="addOption()">add</mat-icon>
        </mat-form-field>

        @if(config.options && config.options.length > 0){
        <div class="chips-container">
            @for(option of config.options; track option) {
            <lib-chip color="muted" [text]="option">
                <mat-icon class="close-icon" (click)="removeOption(option)">close</mat-icon>
            </lib-chip>
            }
        </div>
        }
        }

        @if(config.type == 'date'){
        <app-date-picker [startDate]="config.value || defaultDate" [label]="'events.metric_model_value' | translate"
            (dateChanged)="onDateChanged($event)">
        </app-date-picker>
        }
    </div>
</div>